import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

// Placeras i en position-relative-behållare tillsammans med ett fält med klassen
// password-input, som lämnar plats åt ikonen.
export default function PasswordVisibilityButton({ visible, onToggle }) {
  const intl = useIntl();
  const label = intl.formatMessage({
    id: visible ? "HidePassword" : "ShowPassword",
  });

  return (
    <button
      type="button"
      className="password-visibility-button"
      // Behåll fokus i fältet, annars fäller mobilen ner tangentbordet vid varje tryck.
      onMouseDown={(e) => e.preventDefault()}
      onClick={onToggle}
      title={label}
      aria-label={label}
      aria-pressed={visible}
    >
      <FontAwesomeIcon icon={visible ? "eye-slash" : "eye"} />
    </button>
  );
}
